module.exports = __webpack_public_path__ + "img/logo.6a54f681.png";